import { QueryClient } from 'react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 60s
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
      notifyOnChangePropsExclusions: ['isStale'],
    },
  },
});

export { queryClient };
